import React from 'react';

import logo from "assets/img/logo_cordilheira.svg";

import CircularProgress from '@material-ui/core/CircularProgress';

import withStyles from "@material-ui/core/styles/withStyles";

import splashscreenStyle from "assets/jss/splashscreen.jsx";

class Splashscreen extends React.Component {

  render() {
    const {classes} = this.props;
    let splashBox;
    if (this.props.children)
      splashBox = (<div className="splashBox animated fadeInUp">
        <div className="container">
          {this.props.children}
        </div>
      </div>);
    return (
      <React.Fragment>
        <div className={classes.splashBackground}/>
        <div className={classes.Splashscreen + (this.props.children ? " withBox" : "")}>
          <div className="logo" style={{backgroundImage: "url(" + logo + ")"}}/>
          <div className="loadingTextContainer">
            <CircularProgress className={"progress"} size={150} thickness={1} style={{color: "#111111"}}/>
            <h3>Aguarde..</h3>
          </div>
          {splashBox}
        </div>
      </React.Fragment>
    );
  }
}

export default withStyles(splashscreenStyle)(Splashscreen);